import { render } from "./ContactEdit.html?vue&type=template&id=8545a168&scoped=true&ts=true"
import script from "./ContactEdit.ts?vue&type=script&lang=ts"
export * from "./ContactEdit.ts?vue&type=script&lang=ts"

import "./ContactEdit.css?vue&type=style&index=0&id=8545a168&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8545a168"]])

export default __exports__